import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { PortfolioDTO } from '../../api/useSubmitAnswersMutation';
import { Content } from '../../components/Content/Content';
import { Card } from '../../../CommonComponents/OPL/Card/Card';
import { AssetAllocationChart } from './components/AssetAllocationChart/AssetAllocationChart';
import { StickyFooter } from '../../../CommonComponents/OPL/StickyFooter/StickyFooter';

interface Props {
  portfolio: PortfolioDTO;
  onRestart(): void;
  onFinish(): void;
}

export const Results: React.FC<Props> = ({ portfolio, onRestart, onFinish }) => {
  return (
    <>
      <Content>
        <ResultsContent portfolio={portfolio} />
      </Content>

      <StickyFooter>
        <Button onClick={onRestart} variant="secondary" size="large">
          Edit My Answers
        </Button>

        <Button onClick={onFinish} size="large">
          Confirm my Risk Score
        </Button>
      </StickyFooter>
    </>
  );
};

interface ResultsContentProps {
  isPrint?: boolean;
  portfolio: PortfolioDTO;
}

export const ResultsContent: React.FC<ResultsContentProps> = ({ portfolio, isPrint }) => {
  return (
    <Box mt={96} minWidth={864}>
      <Text fontSize="h5" color="neutral.500" fontWeight={500} textAlign="center" mb="4">
        Based on your answers, your risk score is:
      </Text>

      <Text variant="tabular" fontSize="xl" fontWeight={600} textAlign="center" mb="32">
        {portfolio.Score}
      </Text>

      <Card width={640} p="32" mx="auto" hasBorder={isPrint} boxShadow={isPrint ? 'none' : '400'}>
        <Text color="neutral.500" fontWeight={500} textAlign="center" mb="8">
          The portfolio that aligns closest with your risk objective is:
        </Text>

        <Text fontSize="h5" color="neutral.600" fontWeight={600} textAlign="center" mb="4">
          {portfolio.Name}
        </Text>

        <AssetAllocationChart portfolio={portfolio} isPrint={isPrint} mt={27} mb="24" />

        {portfolio.Description && (
          <Box mx={-32} mb={-32} bg="neutral.100" px="48" py="24">
            <Text fontWeight={500} color="neutral.600">
              {portfolio.Description}
            </Text>
          </Box>
        )}
      </Card>
    </Box>
  );
};
